export const getRegionName = (region, translations) => {
    switch (region) {
        case 'NORWAY':
            return translations.norway;
        case 'EUROPE_NORTH':
            return translations.europeNorth;
        case 'SWEDEN':
            return translations.sweden;
        case 'BALTICS':
            return translations.baltics;
        case 'EUROPE':
            return translations.europe;
        case 'GLOBAL':
            return translations.global;
        case 'UNITED_STATES_OF_AMERICA':
            return translations.unitedStatesOfAmerica;
        case 'ASIA_PACIFIC':
            return translations.asiaPacific;
        case 'ASIA_PACIFIC_EX_JAPAN_EX_AUSTRALIA':
            return translations.asiaPacificExJapanExAustralia;
        case 'JAPAN':
            return translations.japan;
        case 'INDIA':
            return translations.india;
        case 'BRAZIL':
            return translations.brazil;
        case 'CHINA':
            return translations.china;
        case 'CHINA_GREATER':
            return translations.chinaGreater;
        case 'THAILAND':
            return translations.thailand;
        case 'LATIN_AMERICA':
            return translations.latinAmerica;
        case 'BRIC_BRAZIL_RUSSIA_INDIA_AND_CHINA':
            return translations.bricBrazilRussiaIndiaAndChina;
        case 'EUROPE_EMERGING_MARKETS':
            return translations.europeEmergingMarkets;
        case 'GLOBAL_EMERGING_MARKETS':
            return translations.globalEmergingMarkets;
        case 'EMERGING_EUROPE_MIDDLE_EAST_AND_AFRICA':
            return translations.emergingEuropeMiddleEastAndAfrica;
        case 'UNKNOWN':
        default:
            return undefined;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXJlZ2lvbi1uYW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2FwcHMvZnVuZC1saXN0L3V0aWxzL2dldC1yZWdpb24tbmFtZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsQ0FBQyxNQUFjLEVBQUUsWUFBb0MsRUFBRSxFQUFFO0lBQ2xGLFFBQVEsTUFBTSxFQUFFLENBQUM7UUFDYixLQUFLLFFBQVE7WUFDVCxPQUFPLFlBQVksQ0FBQyxNQUFNLENBQUM7UUFDL0IsS0FBSyxjQUFjO1lBQ2YsT0FBTyxZQUFZLENBQUMsV0FBVyxDQUFDO1FBQ3BDLEtBQUssUUFBUTtZQUNULE9BQU8sWUFBWSxDQUFDLE1BQU0sQ0FBQztRQUMvQixLQUFLLFNBQVM7WUFDVixPQUFPLFlBQVksQ0FBQyxPQUFPLENBQUM7UUFDaEMsS0FBSyxRQUFRO1lBQ1QsT0FBTyxZQUFZLENBQUMsTUFBTSxDQUFDO1FBQy9CLEtBQUssUUFBUTtZQUNULE9BQU8sWUFBWSxDQUFDLE1BQU0sQ0FBQztRQUMvQixLQUFLLDBCQUEwQjtZQUMzQixPQUFPLFlBQVksQ0FBQyxxQkFBcUIsQ0FBQztRQUM5QyxLQUFLLGNBQWM7WUFDZixPQUFPLFlBQVksQ0FBQyxXQUFXLENBQUM7UUFDcEMsS0FBSyxvQ0FBb0M7WUFDckMsT0FBTyxZQUFZLENBQUMsNkJBQTZCLENBQUM7UUFDdEQsS0FBSyxPQUFPO1lBQ1IsT0FBTyxZQUFZLENBQUMsS0FBSyxDQUFDO1FBQzlCLEtBQUssT0FBTztZQUNSLE9BQU8sWUFBWSxDQUFDLEtBQUssQ0FBQztRQUM5QixLQUFLLFFBQVE7WUFDVCxPQUFPLFlBQVksQ0FBQyxNQUFNLENBQUM7UUFDL0IsS0FBSyxPQUFPO1lBQ1IsT0FBTyxZQUFZLENBQUMsS0FBSyxDQUFDO1FBQzlCLEtBQUssZUFBZTtZQUNoQixPQUFPLFlBQVksQ0FBQyxZQUFZLENBQUM7UUFDckMsS0FBSyxVQUFVO1lBQ1gsT0FBTyxZQUFZLENBQUMsUUFBUSxDQUFDO1FBQ2pDLEtBQUssZUFBZTtZQUNoQixPQUFPLFlBQVksQ0FBQyxZQUFZLENBQUM7UUFDckMsS0FBSyxvQ0FBb0M7WUFDckMsT0FBTyxZQUFZLENBQUMsNkJBQTZCLENBQUM7UUFDdEQsS0FBSyx5QkFBeUI7WUFDMUIsT0FBTyxZQUFZLENBQUMscUJBQXFCLENBQUM7UUFDOUMsS0FBSyx5QkFBeUI7WUFDMUIsT0FBTyxZQUFZLENBQUMscUJBQXFCLENBQUM7UUFDOUMsS0FBSyx3Q0FBd0M7WUFDekMsT0FBTyxZQUFZLENBQUMsaUNBQWlDLENBQUM7UUFDMUQsS0FBSyxTQUFTLENBQUM7UUFDZjtZQUNJLE9BQU8sU0FBUyxDQUFDO0lBQ3pCLENBQUM7QUFDTCxDQUFDLENBQUMifQ==